<template>
  <div class="is-relative">
    <p class="has-text-centered">
      <b-icon
    pack="fas"
    icon="circle-notch"
    class="fa-spin is-primary"
    v-show="loading"
    />
      {{ loading ? 'Analyzing portfolio' : '&nbsp;' }}
    </p>

    <div v-if="readyToOptimize">
      <div class="rows">
        <div class="row" style="margin-bottom:20px">
          <p class="title is-4">{{ $root.iframed ? 'Optimization Strategy' : 'Index Builder' }}</p>
        </div>
        <div class="row">
          Benchmark Portfolio  <TypeaheadPortfolioSearch :selected="benchmark" :callback="selectBenchmark" />
        </div>
        <div class="row">
          <div class="columns">

            <div class="column">
              <label class="is-size-7">Optimization Type</label>
              <div class="select">
              <select v-model="optimizerType">
                <option value="minTracking">Min Tracking</option>
                <option value="inclusion">Inclusion</option>
                <option value="factor_no_filter">Factor</option>
                <option value="best_no_filter">Best with Same Risk</option>
                <option v-if="northfieldEnabled" value="northfield">NorthField</option>
              </select>
            </div>
              <a><i v-on:click="showModal" class='fas fa-info-circle mx-2'></i></a>
    
            </div>
            <div class="column one-third">
              <label class="is-size-7">Maximum Holdings</label>
              <div class="select">
              <select v-model="maxHoldings">
                <option value="0">Unlimited</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="100">100</option>
                <option value="230">230</option>
                <option value="250">250</option>
                <option value="500">500</option>
                <option value="750">750</option>
                <option value="1000">1000</option>

              </select>
              <input v-if="maxHoldings!='0'" v-model="balanceMarketCap" type='checkbox' class="is-size-7" /><label v-if="maxHoldings!='0'" class="is-size-7">Balance Securities by Market Cap</label>
            </div>
            </div>
            <div class="column one-third">
              <label class="is-size-7">&nbsp;</label>
              <div>
              <b-button class="is-medium is-primary is-pulled-right" v-if="!isLoading" v-on:click="doApiCall">Optimize</b-button>
              </div>
            </div><!-- row -->
          </div>
        </div>
        
      </div><!-- rows -->
      <div v-if="diagnostics && !loading">
        <a
          v-if="optimizedPortfolio"
          v-bind:href="downloadOptimalWeights"
          v-bind:download="universe.name + 'customized.csv'"
        >
          <span v-if="diagnostics && !loading" class="is-size-7">Download Portfolio Weights</span>
          <span v-if="diagnostics && !loading" class="icon has-text-primary">
            <i class="fas fa-download"></i>
          </span>
        </a>
        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Tracking Error</p>
              <p class="title is-5">{{ (diagnostics.trackingError * 100).toFixed(2) }}%</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Your Sharpe</p>
              <p class="title is-5">{{ (diagnostics.optimalSharpe).toFixed(2) }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Benchmark Sharpe</p>
              <p class="title is-5">{{ (diagnostics.benchmarkSharpe).toFixed(2) }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered" v-if="diagnostics.percentInclusions && diagnostics.percentInclusions >.0001">
            <div>
              <p class="heading">Inclusion Ratio</p>
              <p class="title is-5">{{ (diagnostics.percentInclusions*100).toFixed(2) }}%</p>
            </div>
          </div>

        </nav>
      </div>
      <p v-if="optimizedPortfolio && diagnostics" class="title is-6 has-text-centered mt-5">5y Performance</p>
      <LineChart
        v-if="optimizedPortfolio && diagnostics"
        :options="chartOptions"
        :chart-data="chartData"
        :width="500"
        :height="300"
      />
      <b-loading v-model="loading" :can-cancel="false" :is-full-page="false"></b-loading>
      <hr v-if="optimizedPortfolio && diagnostics"/>
      <div v-if="optimizedPortfolio && diagnostics">

      <p class="title is-4" v-if="!$root.iframed">
        Index Impact &nbsp;&nbsp;
          <a
            v-bind:href="reportUrl"
            target="_blank"
          >
            <b-icon pack="fas" icon="external-link-alt"/>
          </a>
  
          &nbsp;&nbsp;
          <a
            href="/advisor-dashboard/metric-alerts/"
            target="_blank"
          >
            <b-icon pack="fas" icon="bell"/>
          </a>
        
      </p>
      <b-button v-if="optimizedPortfolio && diagnostics" class="base1 slightCurvedBorder pointer rightMargin rightPadding"
      :style="{ backgroundColor: 'rgba(128, 94, 230, 0.2)' }"
      @click="savePortfolio"
    >
      <p v-if="isDraft" class="base1Text heavy leftMargin topBottomHalfMargin fontSizeThreeQuarters inlineBlockDisplay">
        Save draft portfolio
      </p>
      <p v-else class="base1Text heavy leftMargin topBottomHalfMargin fontSizeThreeQuarters inlineBlockDisplay">
        Save portfolio
      </p>
    </b-button>
      <div v-if="relativeMetrics && !$root.iframed">
        <div v-for="(row, index) in relativeMetrics" v-bind:key="row.metric_description_id">
          <hr v-show="index !== 0"/>
          <div class="columns is-vcentered">
            <div class="column is-half">
              <p class="title is-5">{{ row.name}}</p>
            </div><!-- column -->
            <div class="column is-half has-text-right is-right">
              <nav class="level">
                <div class="level-item has-text-centered">
                  <div>
                    <p class="title is-5">
                      {{ row.relative_benchmark_comp }}%
                    </p>
                    <p class="heading">
                      {{ row.star ? 'better' : 'worse' }} than the benchmark.
                    </p>
                  </div>
                </div>
              </nav>
            </div><!-- column -->
          </div><!-- columns -->

          <table style="width: 100%">
            <tr>
              <td style="width: 50%; text-align: right; border-style: solid; border-color: grey; border-width: 0px">
              </td>
              <td style="width: 50%; border-style: solid; border-color: grey; border-width: 0px;">
                <div class="hackbars left" :style="row.star ? 'display: none' : `width: ${row.relative_benchmark_comp}%`"></div>
                <div class="hackbars" :style="row.star ? `width: ${row.relative_benchmark_comp}%` : 'display: none'"></div>

              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>

  <b-modal id="optimization_info" title="Optimization Info">
  </b-modal>
</div>

</template>

<script>
  import papa from 'papaparse';
  import LineChart from '@frontend/builder/js/components/LineChart.js';

  import {preciseRound} from '@frontend/shared/Util.js';
  import eventBus from '@frontend/shared/EventBus.js';
  import gql from 'graphql-tag'
  import OptimizerInfo from './OptimizerInfo.vue'
  import telemetry from '@frontend/api/Telemetry.js';
  import TypeaheadPortfolioSearch from '@frontend/dash3/js/components/portfolios/TypeaheadPortfolioSearch.vue';
  import { getPortfolio } from '@frontend/api/api.js';



  export default {
    data() {
      return {
        optimizedPortfolio: {},
        optimizationId: null,
        draftPortfolioId: false,
        isDraft:true,
        modelPortfolioId: false,
        draftPortfolioNickname: "",
        relativeMetrics: {},
        diagnostics: false,
        loading: false,
        optimizerType: "minTracking",
        maxHoldings:0,
        balanceMarketCap:false,
        benchmark: false,
        initialBenchmark: false
      }
    },
    async beforeMount() {
      let key = this.universe.key
      if (isNaN(key)) {
        key = '$' + key;
      }

      this.benchmark = (await getPortfolio(key)).data.portfolio;
      this.initialBenchmark = this.benchmark;
    },
    apollo: {
      optimization: {
        query: gql`query Optimization($optimizationId:Int!,$metrics:[Int]) {
          optimization(id:$optimizationId) {
            pk
            taskStatus
            optimizationtickerSet {
              weight
              ticker {
                symbol
              }
            }
            diagnostics {
              chartDates
              benchmarkValues
              optimalValues
              trackingError
              benchmarkSharpe
              optimalSharpe
              percentInclusions
            }
            draftPortfolio {
              pk
              nickname
              externalId
            }
            benchmarkPortfolio {
              pk
              externalId
            }
            benchmarkComparison(metrics:$metrics)
          }
        }`,
        errorPolicy:'ignore',
        fetchPolicy:"no-cache",
        update(data) {
          if(data.optimization.taskStatus == 'complete') {
            this.optimizedPortfolio = {}
            data.optimization.optimizationtickerSet.forEach((node)=>{
                this.optimizedPortfolio[node.ticker.symbol] = node.weight
            })
            this.draftPortfolioId = data.optimization.draftPortfolio.externalId
            this.isDraft = true
            this.draftPortfolioNickname = data.optimization.draftPortfolio.nickname
            this.modelPortfolioId = data.optimization.benchmarkPortfolio.externalId
            this.diagnostics = data.optimization.diagnostics
            this.relativeMetrics = JSON.parse(data.optimization.benchmarkComparison)

            this.loading = false
            this.optimizationId = null
            this.$apollo.queries.optimization.stop()
          }
          else if(data.optimization.taskStatus == 'failed') {
            alert("Unable to optimize portfolio")
            this.loading = false
            this.optimizationId = null
            this.$apollo.queries.optimization.stop()
          }
        },
        throttle:1000,
        variables() {
          let metrics = this.screens.map((screen)=> {
            return(screen.pk)
          })
          return ({optimizationId: parseInt(this.optimizationId), metrics })
        },
        pollInterval:1000,
        skip:function() {
          return(this.optimizationId == null || !this.loading)
        }
      }
    },
    props: {
      universe: Object,
      results: Object,
      screens: Array,
      flaggedTable: Object,
      portfolio: Object,
      isLoading: Boolean
    },
    components: {
      LineChart,
      TypeaheadPortfolioSearch
    },
    computed: {
      readyToOptimize() {
        return this.screens.length != 0 && !this.loading && !this.isLoading
      },
      northfieldEnabled() {
        return this.$root.advisor.hasFeature('Northfield')
      },
      downloadOptimalWeights() {
        if (!this.optimizedPortfolio) {
          return '';
        }
        let totalWeight = Object.entries(this.portfolio).reduce((acc,item) => {
          return (acc+item[1])
        },0)
        let csvFile = papa.unparse(Object.entries(this.portfolio).reduce((acc, itm) => {
          let newWeight = this.optimizedPortfolio[itm[0]] ? this.optimizedPortfolio[itm[0]] : 0;
          acc.push({
            'Ticker': itm[0],
            'New Weight': newWeight,
            'Original Weight': itm[1]/totalWeight,
          });
          return acc;
        }, []));
        csvFile = `"
          Copyright Stake PBC. All rights reserved. You may not use the information contained herein as the basis for any derivative product
          (including, without limitation, constructing, modifying, or maintaining any index or passively managed investment products)
          without the express written consent of Stake PBC.
          The information, data, analyses and opinions contained herein
          (1) include the proprietary information of Stake PBC, or third party content providers
          (2) may not be copied or redistributed, (3) do not constitute investment advice offered by Stake PBC
          (4) are provided solely for informational purposes
          (5) are not warranted to be timely, complete or accurate. Except to the extent otherwise specifically
              required by law, neither Stake PBC, nor its affiliates nor their third party content providers shall
              be responsible for any trading decisions, damages or other losses resulting from, or related to, this
              information, data, analyses, opinions or their use.
        "\n\n` + csvFile;

        telemetry.track('Downloaded Export', { type: 'optimized results' });
        return `data:text/csv;charset=utf-8,${encodeURIComponent(csvFile)}`;
      },
      chartOptions() {
        return {
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {
              // min: 8500,
              // max: 11500,
              stepSize: 500
            }
          },
        };
      },
      chartData() {
        if (!this.diagnostics) {
          return {};
        }
        const data = {
          labels: this.diagnostics.chartDates,
          datasets: [{
            borderColor: ['darkblue'],
            borderWidth: 1,
            data: this.diagnostics.benchmarkValues,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            tension: 0.1,
            label: 'Benchmark',
          },{
            borderColor: ['orange'],
            borderWidth: 1,
            data: this.diagnostics.optimalValues,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            tension: 0.1,
            label: 'New Portfolio'
          }],
        };
        return data;
      },
      reportUrl() {
        if (!this.draftPortfolioId || !this.modelPortfolioId) {
          return '#';
        }
        const queryArgs = {
          reportStyle: 'minimal',
          reportType: 'impact',
          reporting: this.draftPortfolioId,
          benchmark: this.modelPortfolioId,
        };
        queryArgs.screens = this.screens.map((itm) => {
          return itm.pk
        }).join(',');

        const existingParams = new URLSearchParams(window.location.search);
        if (existingParams.get('values_from')) {
          queryArgs.values_from = existingParams.get('values_from');
        }

        return `/ui/advisor/reports/?${new URLSearchParams(queryArgs)}`;
      }
    },
    methods: {
      selectBenchmark(benchmark) {
        this.benchmark = benchmark;
      },
      doApiCall: async function() {
        if(this.screens.length ==0 ) {
          return
        }
        this.loading = true;

        const nonFlaggedTickers = new Set(this.flaggedTable.data.filter((i) => { return i.flagged_total ==0 }).map((i) => { return i.symbol }));
        const includedTickers = new Set(this.flaggedTable.data.filter((i) => { return i.included_total > 0 }).map((i) => { return i.symbol }));
        const tickers = Array.from(nonFlaggedTickers).map((ticker)=> {
          return {symbol:ticker,minWeight:0.0,maxWeight:1.0,isInclusion:includedTickers.has(ticker)}
        })
        const mutation = gql`mutation optimizer($portfolioId:String!,$tickers:[OptimizerTickerInput],$startDate:Date,$endDate:Date,$optimizerType:String,$metrics:[Int],$maxHoldings:Int!,$useDirectHoldings:Boolean, $balanceMarketCap:Boolean) {
                        startOptimization(tickers:$tickers, modelPortfolioId:$portfolioId,
                        startDate:$startDate,endDate:$endDate, optimizationType:$optimizerType,maxHoldings:$maxHoldings, metrics:$metrics,useDirectHoldings:$useDirectHoldings, balanceMarketCap:$balanceMarketCap) {
                          optimization {
                            id
                          }
                        }
                      }`
        const startDate = (new Date(new Date().setFullYear(new Date().getFullYear() - 5))).toISOString().slice(0,10)
        const endDate = (new Date()).toISOString().slice(0,10)
        const metrics = this.screens.map((screen)=> {
            return(screen.pk)
          })
        this.$apollo.mutate({mutation,
                            variables:{startDate,endDate,portfolioId:this.benchmark.id.toString(),
                                      tickers,metrics,
                                      optimizerType:this.optimizerType,
                                      maxHoldings:parseInt(this.maxHoldings),
                                      useDirectHoldings:(this.benchmark.id == this.initialBenchmark.id && this.universe.type == 'model_portfolio_direct'),
                                      balanceMarketCap:this.balanceMarketCap
                                      }
        }).then((data)=> {
          if(data.data && data.data.startOptimization) {
            this.optimizationId = data.data.startOptimization.optimization.id
            this.$apollo.queries.optimization.start(1000)
          }              
        })
      },
      async doSave(value) {
        const mutation = gql`mutation SavePortfolio($portfolioId:String,$nickname:String) {
                          savePortfolio(portfolioId:$portfolioId,nickname:$nickname) {
                            success
                          }
                      }`

        const resp = await this.$apollo.mutate({mutation, variables:{portfolioId:this.draftPortfolioId,nickname:value}})
        if(resp.data && resp.data.savePortfolio && resp.data.savePortfolio.success) {
          this.$buefy.toast.open(`Saved portfolio as ${value}`);
          this.draftPortfolioNickname = value
          this.isDraft = false
        } else {
          this.$buefy.toast.open(`Failed to save portfolio`);
        }
      },
      showModal() {
        this.$buefy.modal.open({
          parent: this,
          component: OptimizerInfo,
          hasModalCard: true,
          trapFocus: true,
          props: {}
        })
      },
      savePortfolio() {
        this.$buefy.dialog.prompt({
          message: "Save this portfolio as:",
          inputAttrs: {
              placeholder: this.draftPortfolioNickname,
              maxlength: 200,
              value: this.draftPortfolioNickname,
          },
          trapFocus: true,
          closeOnConfirm: false,
          confirmText: 'Save',
          onConfirm: async (value, {close}) => {
            this.$buefy.toast.open(`Saving as: ${value}...`);
            await this.doSave(value);
            close();
          }
        })
      }
    },
    watch: {
      flaggedTable: function() {
        this.diagnostics = false
        const includedTickers = new Set(this.flaggedTable.data.filter((i) => { return i.included_total > 0 }).map((i) => { return i.symbol }));
        if(includedTickers.size > 0) {
          this.optimizerType = 'inclusion';
        } else if(this.optimizerType == 'inclusion') {
          this.optimizerType = 'minTracking'
        }
        //this.doApiCall();
      },
      optimizerType: function() {
        this.diagnostics = false
        //this.doApiCall();
      },
      universe: function() {
        this.optimizationId = null
        this.loading = false
        this.diagnostics = false
      }
    },
    mounted: async function() {
    },
  }
</script>

<style lang="scss">
  .hackbars {
    height: 15px;
    background-color: #34a85c;

    &.left {
      background-color: #f14668;
    }
  }

</style>
